import { DefaultVariantProps } from "./props";
import { PlatformsImage } from "../../../core";

import styles from "./default.module.scss";
import Caroussel from "../../carroussel";

export default function DefaultVariant({
  openLightboxOnSlide,
  vehicleImagesThumb,
  vehicle,
}: DefaultVariantProps) {
  const images = vehicleImagesThumb;

  return (
    <div className={styles.container}>
      <Caroussel
        itemsPerView="3"
        itens={images.map((i, idx) => (
          <PlatformsImage
            width={600}
            height={500}
            onClick={() =>
              openLightboxOnSlide(vehicleImagesThumb.length > idx ? idx + 1 : 1)
            }
            src={
              vehicleImagesThumb.length > idx
                ? vehicleImagesThumb[idx]
                : vehicleImagesThumb[0]
            }
            alt={`Imagem exterior do veículo ${vehicle.model} ${vehicle.modelYear} ${vehicle.version} `}
            className={styles.image}
            preload={idx <= 1}
            priority={idx <= 1}
          />
        ))}
      />
    </div>
  );
}
